<ng-container [formGroup]="form">
	<div class="grid grid-cols-1 2xl:grid-cols-2 gap-6">
		<spr-coach-settings-general-information
			[informationForm]="form"
			class="2xl:row-span-3"
		></spr-coach-settings-general-information>
		<spr-coach-settings-general-sectors
			[sectorsForm]="form"
		></spr-coach-settings-general-sectors>
		<spr-coach-settings-external-connection
			[networkType]="'OUTLOOK'"
		></spr-coach-settings-external-connection>
		<!--		<spr-coach-settings-external-connection-->
		<!--			[networkType]="'GOOGLE'"-->
		<!--		></spr-coach-settings-external-connection>-->
		<spr-coach-settings-general-biography
			[biographyForm]="form"
			class="2xl:col-span-2"
		></spr-coach-settings-general-biography>
		<p-card
			[header]="
				'presentation.app.page.settings.coach.general.references.header' | translate
			"
			class="2xl:col-span-2"
		>
			<div class="space-y-3">
				<spr-coach-settings-general-diploma
					[diplomaForm]="form"
				></spr-coach-settings-general-diploma>
				<spr-coach-settings-general-certificates
					[certificateForm]="form"
				></spr-coach-settings-general-certificates>
			</div>
		</p-card>

		<div class="2xl:col-span-2 justify-self-end">
			<button
				*ngIf="!(isSaving$ | async)"
				[disabled]="!(formValid$ | async)"
				[label]="
					'presentation.app.page.settings.coach.general.submit.label' | translate
				"
				(click)="onUpdateClick()"
				pButton
			></button>
			<p-progressSpinner
				*ngIf="isSaving$ | async"
				[style]="{ width: '30px', height: '30px' }"
			></p-progressSpinner>
		</div>
	</div>
</ng-container>
